<template>

<div class="page-content">
    <div class="container">

        <div class="row">
            <div class="col-12">

                <div class="page-header">
                    <!-- Breadcrumbs -->
                    <nav aria-label="breadcrumb" class="breadcrumb-holder">
                      <ol class="breadcrumb">
                        <li class="breadcrumb-item"><a href="/">Home</a></li>
                        <li class="pl-1 pr-1"><span class="icon icon-arrow-right"></span></li>
                        <li class="breadcrumb-item active" aria-current="page">
                            Crypto Payments
                        </li>
                      </ol>
                    </nav>

                    <!-- Title -->
                    <h1 class="page-title text-center text-uppercase">
                        My Crypto Payments
                    </h1>
                </div>

            </div>
        </div>

        <div class="row">
            <div v-if='isReady' class="col-12">

                <table class="table table-striped table-left">
                    <thead>
                        <tr>
                            <th>Status</th>
                            <th>Amount</th>
                            <th>Subscription</th>
                            <th></th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr v-for='p in payments'>
                            <td>

                                <span :class='getStatusClass(p.status)'>
                                    {{ getStatusLabel(p.status) }}
                                </span>
                                <i>{{ p.status_text }}</i>

                            </td> 

                            <td>{{ p.amountf }} {{ p.coin }}</td>
                            <td>{{ getPlanInfo( p.payload ) }}</td>
                            <td>
                                <a :href='p.redirect_url' target="_blank">
                                    Preview
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>

            </div>
        </div>

   </div>
</div>

</template>

<script>
    export default {

        mounted() {

            if( !this.user ) {

                location.href = '/login';

            } else {

                this.getData();
                
            }

        },

        created() {
           
        },

        data() {
            return {
                isReady : false,
                payments : [],
            }
        },

        methods : {

            getData() {

                this.ajax.call('usr:gcps', {}, (r) => {

                    if( r.status == 'success' ) {
                        this.payments = r.data;
                        this.isReady = true;
                    }

                })

            },

            getPlanInfo( p ) {
                if( typeof p == 'string' ) {
                    p = JSON.parse( p );
                }

                return p.plan + ' (' + p.duration + ' days)';
            },

            getStatusLabel( s ) {
                if( s == 1 || s == 100 ) {
                    return 'Success';
                }

                if( s == 0 ) {
                    return 'Pending';
                }

                if( s == -1 ) {
                    return "Canceled/Expired";
                }
            },

            getStatusClass( s ) {
                if( s == 1 || s == 100 ) {
                    return 'badge badge-success';
                }

                if( s == 0 ) {
                    return 'badge badge-warning';
                }

                if( s == -1 ) {
                    return 'badge badge-danger';
                }
            }
        }

    }
</script>
